import axios from "axios";
import router from "../router/index.js";
import { Loading, Message } from "element-ui";
import qs from 'qs';
import {cookie} from '@/assets/js/tools.js';

axios.defaults.timeout = 60000;
// axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.withCredentials=false;
/*
 *请求前拦截
 *用于处理需要请求前的操作
 */
axios.interceptors.request.use(
    config => {

        var token = cookie.get('token');
        // var token='a25ba0e5-0a31-4fbe-b4ee-ab344c1eee74';
        if (token) {
            config.headers["token"] = token;
            // config.headers["cookie"] = "";
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
/*
 *请求响应拦截
 *用于处理数据返回后的操作
 */
axios.interceptors.response.use(
    response => {
        return new Promise((resolve, reject) => {
            const res = response.data;
            if (res.result === 200) {
                resolve(res)
            // token过期
            } else if (res.result == 403) {
                
                // router.beforeEach((to, from, next) => {
                //   });
                // Message.warning("请登录");
                logout();
            } else{
                reject(res)
            }
        })
    },
    error => {
        //断网处理或者请求超时
        if (!error.response) {
            //请求超时
            if (error.message.includes("timeout")) {
                console.log("超时了");
                Message.error("error", "请求超时，请检查互联网连接");
            } else {
                //断网，可以展示断网组件
                console.log("断网了");
                Message.error("error", "请检查网络是否已连接");
            }
            return;
        }
        const status = error.response.status;
        Message.error(error.response.data.msg);
        // switch (status) {
        //     case 500:
        //         Message.error("服务器内部错误");
        //         break;
        //     case 404:
        //         Message.error("未找到远程服务器");
        //         break;
        //     case 401:
        //         Message.warning("用户登录过期，请重新登录");
        //         logout();
        //         break;
        //     case 400:
        //         Message.error("数据异常");
        //         break;
        //     default:
        //         Message.error(error.response.data.message);
        // }
        return Promise.reject(error);
    }
);
/*
 *get方法，对应get请求
 *@param {String} url [请求的url地址]
 *@param {Object} params [请求时候携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params
            })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
    });
}
/*
 *post方法，对应post请求
 *@param {String} url [请求的url地址]
 *@param {Object} params [请求时候携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                // if (err.message) {
                //     Message.error(err.message);
                // }
                reject(err);
            });
    });
}
export function postForm(url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: url,
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            data:qs.stringify(params),//请求参数
        }).then(res => {
                resolve(res);
            }).catch(err => {
                // if (err.message) {
                //     Message.error(err.message);
                // }
                reject(err);
            });
    });
}
export function postUrl(url, params){
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: url,
            params:params
        }).then(res => {
                resolve(res);
            }).catch(err => {
                // if (err.message) {
                //     Message.error(err.message);
                // }
                reject(err);
            });
    });
}
/** 
 *postFile方法，导入文件
 */
export function postFile (url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {
                'Content-Type':'multipart/form-data'
            })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                // if (err.message) {
                //     Message.error(err.message);
                // }
                reject(err);
            });
    });
}

function logout () {
    cookie.remove('token');
    cookie.remove('userRealName');
    cookie.remove('userID');
    router.push("/login").catch(err => { });
}


